import type { Profile } from 'models';
import { Modal } from 'ui';
import { EditProfileModalContent } from './edit-profile-modal-content';

type P = {
  isOpened: boolean;
  onClose: () => void;
  viewer: Profile;
};

const EditProfileModal = ({ isOpened, onClose, viewer }: P) => (
  <Modal isOpened={isOpened} onCancel={onClose} title="Edit profile" width="small">
    <Modal.ScrollableContent paddingBottom={false}>
      <EditProfileModalContent onClose={onClose} viewer={viewer} />
    </Modal.ScrollableContent>
  </Modal>
);

export default EditProfileModal;
